import { FC } from "react";
import { AccessDiffStatus, AccessListDiffProps } from "./types";
import { Column } from "../../../../../../components/containers";
import { AlignItems } from "../../../../../../components/containers/types";
import { Heading } from "../../../../../../components/typography";
import { useThemeStore } from "../../../../../../stores";
import { ACCESS_FA, ALL_ACCESS } from "../../../../../../utils";
import { CheckBox } from "../../../../../../components/inputs";
import { Access } from "../../../types";
import { IconProps } from "../../../../../../assets/icons/types";
import {
  CheckIcon,
  DashIcon,
  PlusWithoutCircleIcon,
} from "../../../../../../assets/icons";
import { Color } from "../../../../../../types";

const getDiffStatusIcon = (diffStatus: AccessDiffStatus): FC<IconProps> => {
  switch (diffStatus) {
    case AccessDiffStatus.New:
      return PlusWithoutCircleIcon;
    case AccessDiffStatus.Deleted:
      return DashIcon;
    default:
      return CheckIcon;
  }
};

const AccessListDiff: FC<AccessListDiffProps> = ({
  access_diff,
  props,
  className = "",
  style = {},
}) => {
  const theme = useThemeStore((s) => s.theme);

  const getAccessDiffStatus = (access: Access): AccessDiffStatus => {
    return access_diff.new.includes(access)
      ? AccessDiffStatus.New
      : access_diff.del.includes(access)
      ? AccessDiffStatus.Deleted
      : AccessDiffStatus.None;
  };

  const getDiffStatusColor = (diffStatus: AccessDiffStatus): Color => {
    switch (diffStatus) {
      case AccessDiffStatus.New:
        return theme.secondary;
      case AccessDiffStatus.Deleted:
        return theme.alert;
      default:
        return theme.textOnBg;
    }
  };

  return (
    <Column
      style={{ width: "100%", ...style }}
      alignItems={AlignItems.Start}
      gap={10}
      props={props}
      className={className}
    >
      <Heading color={theme.textOnBg} size={15}>
        تفاوت سطح دسترسی
      </Heading>
      {ALL_ACCESS.map((access, idx) => {
        const accessDiffStatus = getAccessDiffStatus(access);
        return (
          <CheckBox
            key={access}
            color={theme.textOnBg}
            label={ACCESS_FA[idx]}
            readOnly
            value={accessDiffStatus !== AccessDiffStatus.None}
            size={11}
            Icon={getDiffStatusIcon(accessDiffStatus)}
            activeColor={getDiffStatusColor(accessDiffStatus)}
          />
        );
      })}
    </Column>
  );
};

export default AccessListDiff;
